import NotFoundPage from '@kopapro/components/pages/notFound/notFound';

import { withTranslation } from 'react-i18next';

export default withTranslation()(NotFoundPage);
